import ApiResource from '@/core/http/ApiResource';
import { ContentModel } from '@/core/languageContent';

export interface TicketStatus {
	id: number;
	content: ContentModel[];
	created_time: string;
}

export const useTicketStatus = () => new ApiResource<TicketStatus>('/api/ticket_status');
